module.exports = __webpack_public_path__ + "static/media/sara.15061e1f.png";